import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
window.addEventListener('beforeinstallprompt', (e: Event) => {
  e.preventDefault();
  (window as any).__pwaDeferredPrompt = e;
});

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
